import { DataProps, SimpleFooterWrapper } from 'ui/navigation/components/simple-footer-int';

const SimpleFooterIntTastic = ({ data }: DataProps) => {
  return <SimpleFooterWrapper data={data} />;
};

export default SimpleFooterIntTastic;
